module.exports = __webpack_public_path__ + "static/img/KH.fa8b1530.png";